import {REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE} from '/enum/records.enum';

export default {
  reportName: REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE,
};
